import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M15 8H13V5C13 2.2 10.8 0 8 0C5.2 0 3 2.2 3 5V8H1C0.4 8 0 8.4 0 9V19C0 19.6 0.4 20 1 20H15C15.6 20 16 19.6 16 19V9C16 8.4 15.6 8 15 8ZM5 5C5 3.3 6.3 2 8 2C9.7 2 11 3.3 11 5V8H5V5ZM14 18H2V10H4H12H14V18Z" />,
  'Lock',
  18,
  '0 0 18 18'
)
